export default __webpack_public_path__ + "static/media/t_error.6a151eff.svg";